import { SVGProps } from 'react';

export const TriangleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.5 1.00098C0.500176 0.623251 0.903318 0.382148 1.23633 0.560547L12.1182 6.39062C12.47 6.57912 12.47 7.08299 12.1182 7.27148L1.23633 13.1016C0.903318 13.28 0.500176 13.0389 0.5 12.6611V1.00098Z"
        stroke="currentColor"
      />
    </svg>
  );
};
